var PubSub = require("underpub-js");
const { gsap } = require("gsap/dist/gsap");

var portfolio = function(options) {
	this.options = {
		$el: false,
		baseClass: 'comp-Portfolio',
	};

	$.extend(true, this.options, options);
};

portfolio.prototype.init = function() {
	
	var self = this;

	self.$filtersWrapper = self.options.$el.find(`.${self.options.baseClass}__filtersWrapper`);
	self.$filters = self.options.$el.find(`.${self.options.baseClass}__filter`);
	self.$filterButton = self.options.$el.find(`.${self.options.baseClass}__filtersApplyButton`);
	self.$filtersCollapseToggle = self.options.$el.find(`.${self.options.baseClass}__filtersToggle`);
	self.$filtersCollapseToggleArrow = self.options.$el.find(`.${self.options.baseClass}__filtersToggle__arrow`);
	self.$activeFilterTags = self.options.$el.find(`.${self.options.baseClass}__activeFilterTag`);

	self.$filterButton.on('click', function() {
		self.submitFilters();
	});

	self.initFilterCollapseToggle();

	self.$activeFilterTags.on('click', function() {
		self.removeActiveFilter($(this));
	});

};

portfolio.prototype.submitFilters = function() {
	
	var self = this;

	// get filters and assemble URL
	let submitFiltersUrl = '//' + location.host + location.pathname;

	// get selected filters
	let $checkedFilters = self.options.$el.find(`.${self.options.baseClass}__filter:checked`);

	let checkedFilterIds = [];

	$checkedFilters.each(function(i) {
		let filterId = $(this).val();
		checkedFilterIds.push(filterId);
	});

	if (checkedFilterIds.length) {
		submitFiltersUrl += '?markets=' + checkedFilterIds.join('|');
	}

	window.location.href = submitFiltersUrl;
	this.setButtonToLoading();

};

portfolio.prototype.removeActiveFilter = function($activeFilterTag) {

	var self = this;

	gsap.to($activeFilterTag, {
		duration: 0.3,
		opacity: 0.4,
	});

	let filterIdToRemove = $activeFilterTag.data('id');

	let $inputToUncheck = self.options.$el.find(`.${self.options.baseClass}__filter[id="${filterIdToRemove}"]`);

	$inputToUncheck.prop( "checked", false );

	self.submitFilters();

};

portfolio.prototype.setButtonToLoading = function() {

	var self = this;

	this.$filterButton.prop("disabled", true);

};

portfolio.prototype.initFilterCollapseToggle = function() {

	var self = this;

	self.filtersCollapseTl = gsap.timeline({
		paused: true,
		reversed: true,
	})
	.to(self.$filtersWrapper, {
		duration: 0.4,
		height: 'auto',
	})
	.to(self.$filtersCollapseToggleArrow, {
		duration: 0.35,
		rotation: 180,
	}, "<");

	self.$filtersCollapseToggle.on('click', function() {

		if (self.filtersCollapseTl.reversed()) {
			self.filtersCollapseTl.play();
		} else {
			self.filtersCollapseTl.reverse();
		}

	});

};

module.exports = portfolio;
